import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import Topup from "../../../../../styles/img/top-up.png"
import Pending from "../../../../../styles/img/pending.png"
import Instant from "../../../../../styles/img/instant.png"
import { UiHowSectionWorkCol, UiHowSectionWorkColHeading } from '../../../components/common/UiHowSectionWorkCol'

export const  MakeSenseStatement = (props) => {

    return (
        <>
            <UiSingleRow className="sb-aligned-center">
                <UiCol lg="2"><UiHowSectionWorkColHeading title={props.title}/></UiCol>
                <UiCol lg="10">
                    <UiSingleRow>
                        <UiHowSectionWorkCol heading="Instant" image={Instant } content="Your statement is live and always up to date"/>
                        <UiHowSectionWorkCol heading="Pending" image={Pending } content="Some points will take time to clear for spending."/>
                        <UiHowSectionWorkCol heading="Top Up" image={Topup } content="You can add cash to increase your spending power."/>
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </>
    )
}
